import React from 'react';

import { Typography } from '@material-ui/core';
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';

interface Props {
  innerRef: any;
  innerProps: MenuItemProps;
  isFocused: boolean;
  isSelected: boolean;
  breakWhiteSpace?: boolean;
  data: {
    key?: string;
    id?: string;
    value?: string;
    secondaryText?: string;
  };
}

const SelectOption: React.FC<Props> = ({
  children,
  innerRef,
  innerProps,
  isFocused,
  isSelected,
  breakWhiteSpace,
  data,
}) => (
  <MenuItem
    key={data.key || data.id || data.value}
    buttonRef={innerRef}
    selected={isFocused}
    component="div"
    style={{
      fontWeight: isSelected ? 500 : 400,
      height: 'fit-content',
    }}
    {...innerProps}
  >
    <span>
      <Typography
        style={{
          whiteSpace: breakWhiteSpace ? 'break-spaces' : 'normal',
        }}
      >
        <b>{children}</b>
      </Typography>
      {data.secondaryText && <Typography>{data.secondaryText}</Typography>}
    </span>
  </MenuItem>
);

export default SelectOption;
